const localEndPoints = {
    HOME:"/",
    ABOUT:"/about",
    NEWS:"/news-and-updates",
    CONTACT:"/contact",
    EVENT:"/events",
    SOCIAL:"/social",
    CAREER:"/career",
    COMPANIES:"/our-companies",
}

export default localEndPoints